import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=2cfff324&scoped=true&lang=pug&"
import script from "./TextBox.vue?vue&type=script&lang=coffee&"
export * from "./TextBox.vue?vue&type=script&lang=coffee&"
import style0 from "./TextBox.vue?vue&type=style&index=0&id=2cfff324&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfff324",
  null
  
)

export default component.exports